// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-size: larger;
    background-color: grey;
}

@media screen and (min-width: 800px) {
    /* body {
        padding-right: 15%;
        padding-left: 15%;
    } */
}

@media screen and (min-width: 1600px) {
    /* body {
        padding-right: 15%;
        padding-left: 15%;
    } */
}

code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
    background-color: #b3e6ff;
}

.h-60 {
    height: 60vh;
}

.h-75 {
    height: 75vh;
}

.h-78 {
    height: 78vh;
}

.title {
    text-align: center;
}

.text-center {
    text-align: center !important;
}

.w-25 {
    width: 25vw;
}

.w-50 {
    width: 50vw;
}

.w-75 {
    width: 75vw;
}

.max-w-25 {
    max-width: 25vw;
}

.center {
    margin: 0 auto;
}

/* Login Box */
#loginBox {
    outline: 2px solid green;
    box-shadow: 10px 5px 5px grey;
    padding: 2vh 2vw;
}

input {
    transition: width 0.4s ease-in-out;
    outline: none;
}

select {
    border-radius: 5px;
    border: 1.5px solid black;
}

.m-left-3 {
    margin-left: 3vw;
}

.m-left-2 {
    margin-left: 2vw;
}

.m-right-2 {
    margin-right: 2vw;
}

.m-top-2 {
    margin-top: 2vh;
}

.m-top-3 {
    margin-top: 3vh;
}

.m-top-5 {
    margin-top: 5vh;
}

.m-bot-3 {
    margin-bottom: 3vh;
}

/* Flex */
.f {
    display: flex;
}

.f-wrap {
    flex-wrap: wrap;
}

.justify-end {
    justify-content: end;
}

.justify-space-between {
    justify-content: space-between;
}

.justify-center {
    justify-content: center;
}

.align-center {
    align-items: center;
}

.align-content-center {
    align-content: center;
}

.f-grow-1 {
    flex-grow: 1;
}

.gap-5 {
    gap: 5px;
}

input {
    border: none;
    border-bottom: 2px solid #3F91B8;
}

input:focus {
    border:2px solid #3F91B8;
    background-color: #3F91B8;
    color: white;
    border-radius: 3px;
}

.modalBackground {
    background: white;
    padding: 32px;
    border-radius: 8px;
    min-width: 320;
    box-shadow: 0 2px 16px #333;
}


.blueButton {
    background-color: #3F91B8;
    color: white;
    padding: 10px 20px;
    border-radius: 5px;
    border: none;
    box-shadow: 0 2px 8px rgba(63,145,184,0.2);
    text-decoration: none;
    font-size: medium;
    transition: background 0.2s, transform 0.1s, box-shadow 0.2s;
}

.blueButton:hover {
    background-color: #23648c;
    transform: scale(1.08);
    box-shadow: 0 4px 16px rgba(63,145,184,0.4);
}

.redButton {
    background-color: #d32f2f; /* deep red */
    color: white;
    padding: 10px 15px;
    border-radius: 5px;
    border: none;
    box-shadow: 0 2px 8px rgba(211,47,47,0.2);
    font-size: medium;
    transition: background 0.2s, transform 0.1s, box-shadow 0.2s;
}

.redButton:hover {
    background-color: #b71c1c; /* even deeper red */
    transform: scale(1.08);
    box-shadow: 0 4px 16px rgba(211,47,47,0.4);
}

button:hover {
    cursor: pointer;
}

a {
    background-color: #3F91B8;
    color: white;
    padding: 1vh 1vw;
    border-radius: 5px;
    border: none;
    box-shadow: 5px 3px 5px grey;
    text-decoration: none;
    font-size: medium;
}

a:hover {
    scale: 1.2;
    background-color: #78A858;
    box-shadow: 5px 3px 5px #3F91B8;
}

.delete-row-btn {
    background-color: #d32f2f; /* deep red */
    color: white;
    padding: 10px 15px;
    border-radius: 5px;
    border: none;
    box-shadow: 0 2px 8px rgba(211,47,47,0.2);
    font-size: medium;
    transition: background 0.2s, transform 0.1s, box-shadow 0.2s;
}

.delete-row-btn:hover {
    background-color: #b71c1c; /* even deeper red */
    transform: scale(1.08);
    box-shadow: 0 4px 16px rgba(211,47,47,0.4);
}

.greenButton {
    background-color: #43a047; /* vibrant green */
    color: white;
    padding: 10px 20px;
    border-radius: 5px;
    border: none;
    box-shadow: 0 2px 8px rgba(67,160,71,0.2);
    text-decoration: none;
    font-size: medium;
    transition: background 0.2s, transform 0.1s, box-shadow 0.2s;
}

.greenButton:hover {
    background-color: #2e7031; /* deeper green */
    transform: scale(1.08);
    box-shadow: 0 4px 16px rgba(67,160,71,0.4);
}

.blueBg {
    background-color: #3F91B8;
}

.greenBg {
    background-color: #78A858;
}

.greyBg {
    background-color: grey;
}

.whiteBg {
    background-color: white;
}

.redBg {
    background-color: red;
}

.topBar {
    background-color: white;
    padding: 1% 3%;
    /* opacity: 90%; */
    align-items: flex-end;
    z-index: 1;
    position: relative;
}

.center-text {
    text-align: center;
}

.right-text {
    text-align: right;
}

.white-text {
    color: white;
}

.blue-text {
    color: #3F91B8;
}

.bold-text {
    font-weight: bold;
}

.large-font {
    font-size: large;
}

.underline {
    text-decoration: underline;
}

.ssnBoxPadding {
    padding: 1vh 2vw; 
}

.side-pad-5 {
    padding: 0 5vw;
}

.bot-pad-2 {
    padding-bottom: 2vh;
}

.bot-border-2 {
    border-bottom: 2px solid black;
}

.clientBox {
 text-align: center;
 background-color: white;
 padding: 2vh 2vw;
 margin: 2vh auto;
 border: 2px solid black;
 box-shadow: 10px 5px 5px #3F91B8;
}

.rounded {
    border-radius: 7px;
}

.rounded-5 {
    border-radius: 5px;
}

.highlighted {
    background-color: yellow;
}

/* Date Picker */
.date-picker-container {
    position: relative;
    color: black;
}

.date-picker-wrapper {
    position: absolute;
    top: 100%;
    /* z-index: 1000; */
    margin-top: 20px;
    box-shadow: 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.42), 0 2px 4px -1px rgba(0,0,0,.2);
    border-radius: 4px;
}

.dropdown-input {
    /* width: 100%; */
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    /* font-size: 16px; */
    outline: none;
}

.dropdown-input:hover {
    border-color: #3F91B8;
}

.dropdown-input {
    /* width: 100%; */
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    /* font-size: 16px; */
    outline: none;
}

.dropdown-input:hover {
    border-color: #3F91B8;
}


/* Report Box */
#summaryBox {
    /* width: 95vw; #reportBox is already handling the width */
    /* margin: 0 auto; #reportBox is already handling the margin */
    background-color: #585858;
    font-size: 1.2em;
    margin-bottom: 1vh; /* Adds blank space underneath */
    border-radius: 7px;
}

#summaryText {
    color:white;
    /* font-weight: bold; */
    padding: 20px;
    line-height: 1.5;
}

/* Ensure the overlay covers the full grid area */
.loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.7); /* Grey overlay with transparency */
    display: flex;
    justify-content: center;
    align-items: center;
    /* z-index: 10; */
    border-radius: 8px;
}
  
.spinner {
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-top: 4px solid #3498db;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}
  
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

/* .ag-theme-quartz .ag-tool-panel-wrapper {
    background-color: aqua;


    --ag-selected-tab-underline-color: deeppink;
    --ag-selected-tab-underline-width: 2px;
    --ag-selected-tab-underline-transition-speed: 0.5s;
} */
  
.ag-theme-quartz.loading {
    pointer-events: none; /* Disable interactions while loading */
    opacity: 0.6; /* Dim the grid while loading */
    position: relative;
    height: 100%; /* Ensure grid takes up full height */
}

/* Center the header cells text */
.ag-theme-quartz .ag-header-cell-label {
    justify-content: center;
    font-weight: bold;
}

/* Color the header cells */
.ag-theme-quartz .ag-header {
    background-color: #e8e8e9;
}


/* Color side bar */
.ag-theme-quartz[class*="ag-theme-quartz"] {
    --ag-control-panel-background-color: #e4e4e4;
    --ag-side-button-selected-background-color: #c3e6f7;

    --ag-selected-tab-underline-width: 2px;
    --ag-selected-tab-underline-transition-speed: 0.5s;

}

/* Color the the row group value (if grouped) */
.ag-theme-quartz .ag-column-drop-cell {
    font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI;;;OAGG;AACP;;AAEA;IACI;;;OAGG;AACP;;AAEA;IACI;aACS;IACT,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA,cAAc;AACd;IACI,wBAAwB;IACxB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,SAAS;AACT;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,2BAA2B;AAC/B;;;AAGA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,0CAA0C;IAC1C,qBAAqB;IACrB,iBAAiB;IACjB,4DAA4D;AAChE;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB,EAAE,aAAa;IACxC,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,yCAAyC;IACzC,iBAAiB;IACjB,4DAA4D;AAChE;;AAEA;IACI,yBAAyB,EAAE,oBAAoB;IAC/C,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,4BAA4B;IAC5B,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB,EAAE,aAAa;IACxC,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,yCAAyC;IACzC,iBAAiB;IACjB,4DAA4D;AAChE;;AAEA;IACI,yBAAyB,EAAE,oBAAoB;IAC/C,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB,EAAE,kBAAkB;IAC7C,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,yCAAyC;IACzC,qBAAqB;IACrB,iBAAiB;IACjB,4DAA4D;AAChE;;AAEA;IACI,yBAAyB,EAAE,iBAAiB;IAC5C,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;CACC,kBAAkB;CAClB,uBAAuB;CACvB,gBAAgB;CAChB,gBAAgB;CAChB,uBAAuB;CACvB,gCAAgC;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,oGAAoG;IACpG,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;;AAGA,eAAe;AACf;IACI,0DAA0D;IAC1D,8DAA8D;IAC9D,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB,EAAE,gCAAgC;IACpD,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,aAAa;IACb,gBAAgB;AACpB;;AAEA,iDAAiD;AACjD;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,0CAA0C,EAAE,mCAAmC;IAC/E,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;;;;;;;GAOG;;AAEH;IACI,oBAAoB,EAAE,uCAAuC;IAC7D,YAAY,EAAE,+BAA+B;IAC7C,kBAAkB;IAClB,YAAY,EAAE,qCAAqC;AACvD;;AAEA,iCAAiC;AACjC;IACI,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA,2BAA2B;AAC3B;IACI,yBAAyB;AAC7B;;;AAGA,mBAAmB;AACnB;IACI,4CAA4C;IAC5C,mDAAmD;;IAEnD,sCAAsC;IACtC,kDAAkD;;AAEtD;;AAEA,+CAA+C;AAC/C;IACI,iBAAiB;AACrB","sourcesContent":["body {\n    font-size: larger;\n    background-color: grey;\n}\n\n@media screen and (min-width: 800px) {\n    /* body {\n        padding-right: 15%;\n        padding-left: 15%;\n    } */\n}\n\n@media screen and (min-width: 1600px) {\n    /* body {\n        padding-right: 15%;\n        padding-left: 15%;\n    } */\n}\n\ncode {\n    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n    background-color: #b3e6ff;\n}\n\n.h-60 {\n    height: 60vh;\n}\n\n.h-75 {\n    height: 75vh;\n}\n\n.h-78 {\n    height: 78vh;\n}\n\n.title {\n    text-align: center;\n}\n\n.text-center {\n    text-align: center !important;\n}\n\n.w-25 {\n    width: 25vw;\n}\n\n.w-50 {\n    width: 50vw;\n}\n\n.w-75 {\n    width: 75vw;\n}\n\n.max-w-25 {\n    max-width: 25vw;\n}\n\n.center {\n    margin: 0 auto;\n}\n\n/* Login Box */\n#loginBox {\n    outline: 2px solid green;\n    box-shadow: 10px 5px 5px grey;\n    padding: 2vh 2vw;\n}\n\ninput {\n    transition: width 0.4s ease-in-out;\n    outline: none;\n}\n\nselect {\n    border-radius: 5px;\n    border: 1.5px solid black;\n}\n\n.m-left-3 {\n    margin-left: 3vw;\n}\n\n.m-left-2 {\n    margin-left: 2vw;\n}\n\n.m-right-2 {\n    margin-right: 2vw;\n}\n\n.m-top-2 {\n    margin-top: 2vh;\n}\n\n.m-top-3 {\n    margin-top: 3vh;\n}\n\n.m-top-5 {\n    margin-top: 5vh;\n}\n\n.m-bot-3 {\n    margin-bottom: 3vh;\n}\n\n/* Flex */\n.f {\n    display: flex;\n}\n\n.f-wrap {\n    flex-wrap: wrap;\n}\n\n.justify-end {\n    justify-content: end;\n}\n\n.justify-space-between {\n    justify-content: space-between;\n}\n\n.justify-center {\n    justify-content: center;\n}\n\n.align-center {\n    align-items: center;\n}\n\n.align-content-center {\n    align-content: center;\n}\n\n.f-grow-1 {\n    flex-grow: 1;\n}\n\n.gap-5 {\n    gap: 5px;\n}\n\ninput {\n    border: none;\n    border-bottom: 2px solid #3F91B8;\n}\n\ninput:focus {\n    border:2px solid #3F91B8;\n    background-color: #3F91B8;\n    color: white;\n    border-radius: 3px;\n}\n\n.modalBackground {\n    background: white;\n    padding: 32px;\n    border-radius: 8px;\n    min-width: 320;\n    box-shadow: 0 2px 16px #333;\n}\n\n\n.blueButton {\n    background-color: #3F91B8;\n    color: white;\n    padding: 10px 20px;\n    border-radius: 5px;\n    border: none;\n    box-shadow: 0 2px 8px rgba(63,145,184,0.2);\n    text-decoration: none;\n    font-size: medium;\n    transition: background 0.2s, transform 0.1s, box-shadow 0.2s;\n}\n\n.blueButton:hover {\n    background-color: #23648c;\n    transform: scale(1.08);\n    box-shadow: 0 4px 16px rgba(63,145,184,0.4);\n}\n\n.redButton {\n    background-color: #d32f2f; /* deep red */\n    color: white;\n    padding: 10px 15px;\n    border-radius: 5px;\n    border: none;\n    box-shadow: 0 2px 8px rgba(211,47,47,0.2);\n    font-size: medium;\n    transition: background 0.2s, transform 0.1s, box-shadow 0.2s;\n}\n\n.redButton:hover {\n    background-color: #b71c1c; /* even deeper red */\n    transform: scale(1.08);\n    box-shadow: 0 4px 16px rgba(211,47,47,0.4);\n}\n\nbutton:hover {\n    cursor: pointer;\n}\n\na {\n    background-color: #3F91B8;\n    color: white;\n    padding: 1vh 1vw;\n    border-radius: 5px;\n    border: none;\n    box-shadow: 5px 3px 5px grey;\n    text-decoration: none;\n    font-size: medium;\n}\n\na:hover {\n    scale: 1.2;\n    background-color: #78A858;\n    box-shadow: 5px 3px 5px #3F91B8;\n}\n\n.delete-row-btn {\n    background-color: #d32f2f; /* deep red */\n    color: white;\n    padding: 10px 15px;\n    border-radius: 5px;\n    border: none;\n    box-shadow: 0 2px 8px rgba(211,47,47,0.2);\n    font-size: medium;\n    transition: background 0.2s, transform 0.1s, box-shadow 0.2s;\n}\n\n.delete-row-btn:hover {\n    background-color: #b71c1c; /* even deeper red */\n    transform: scale(1.08);\n    box-shadow: 0 4px 16px rgba(211,47,47,0.4);\n}\n\n.greenButton {\n    background-color: #43a047; /* vibrant green */\n    color: white;\n    padding: 10px 20px;\n    border-radius: 5px;\n    border: none;\n    box-shadow: 0 2px 8px rgba(67,160,71,0.2);\n    text-decoration: none;\n    font-size: medium;\n    transition: background 0.2s, transform 0.1s, box-shadow 0.2s;\n}\n\n.greenButton:hover {\n    background-color: #2e7031; /* deeper green */\n    transform: scale(1.08);\n    box-shadow: 0 4px 16px rgba(67,160,71,0.4);\n}\n\n.blueBg {\n    background-color: #3F91B8;\n}\n\n.greenBg {\n    background-color: #78A858;\n}\n\n.greyBg {\n    background-color: grey;\n}\n\n.whiteBg {\n    background-color: white;\n}\n\n.redBg {\n    background-color: red;\n}\n\n.topBar {\n    background-color: white;\n    padding: 1% 3%;\n    /* opacity: 90%; */\n    align-items: flex-end;\n    z-index: 1;\n    position: relative;\n}\n\n.center-text {\n    text-align: center;\n}\n\n.right-text {\n    text-align: right;\n}\n\n.white-text {\n    color: white;\n}\n\n.blue-text {\n    color: #3F91B8;\n}\n\n.bold-text {\n    font-weight: bold;\n}\n\n.large-font {\n    font-size: large;\n}\n\n.underline {\n    text-decoration: underline;\n}\n\n.ssnBoxPadding {\n    padding: 1vh 2vw; \n}\n\n.side-pad-5 {\n    padding: 0 5vw;\n}\n\n.bot-pad-2 {\n    padding-bottom: 2vh;\n}\n\n.bot-border-2 {\n    border-bottom: 2px solid black;\n}\n\n.clientBox {\n text-align: center;\n background-color: white;\n padding: 2vh 2vw;\n margin: 2vh auto;\n border: 2px solid black;\n box-shadow: 10px 5px 5px #3F91B8;\n}\n\n.rounded {\n    border-radius: 7px;\n}\n\n.rounded-5 {\n    border-radius: 5px;\n}\n\n.highlighted {\n    background-color: yellow;\n}\n\n/* Date Picker */\n.date-picker-container {\n    position: relative;\n    color: black;\n}\n\n.date-picker-wrapper {\n    position: absolute;\n    top: 100%;\n    /* z-index: 1000; */\n    margin-top: 20px;\n    box-shadow: 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.42), 0 2px 4px -1px rgba(0,0,0,.2);\n    border-radius: 4px;\n}\n\n.dropdown-input {\n    /* width: 100%; */\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    /* font-size: 16px; */\n    outline: none;\n}\n\n.dropdown-input:hover {\n    border-color: #3F91B8;\n}\n\n.dropdown-input {\n    /* width: 100%; */\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    /* font-size: 16px; */\n    outline: none;\n}\n\n.dropdown-input:hover {\n    border-color: #3F91B8;\n}\n\n\n/* Report Box */\n#summaryBox {\n    /* width: 95vw; #reportBox is already handling the width */\n    /* margin: 0 auto; #reportBox is already handling the margin */\n    background-color: #585858;\n    font-size: 1.2em;\n    margin-bottom: 1vh; /* Adds blank space underneath */\n    border-radius: 7px;\n}\n\n#summaryText {\n    color:white;\n    /* font-weight: bold; */\n    padding: 20px;\n    line-height: 1.5;\n}\n\n/* Ensure the overlay covers the full grid area */\n.loading-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(255, 255, 255, 0.7); /* Grey overlay with transparency */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    /* z-index: 10; */\n    border-radius: 8px;\n}\n  \n.spinner {\n    border: 4px solid rgba(0, 0, 0, 0.1);\n    border-top: 4px solid #3498db;\n    border-radius: 50%;\n    width: 50px;\n    height: 50px;\n    animation: spin 1s linear infinite;\n}\n  \n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n/* .ag-theme-quartz .ag-tool-panel-wrapper {\n    background-color: aqua;\n\n\n    --ag-selected-tab-underline-color: deeppink;\n    --ag-selected-tab-underline-width: 2px;\n    --ag-selected-tab-underline-transition-speed: 0.5s;\n} */\n  \n.ag-theme-quartz.loading {\n    pointer-events: none; /* Disable interactions while loading */\n    opacity: 0.6; /* Dim the grid while loading */\n    position: relative;\n    height: 100%; /* Ensure grid takes up full height */\n}\n\n/* Center the header cells text */\n.ag-theme-quartz .ag-header-cell-label {\n    justify-content: center;\n    font-weight: bold;\n}\n\n/* Color the header cells */\n.ag-theme-quartz .ag-header {\n    background-color: #e8e8e9;\n}\n\n\n/* Color side bar */\n.ag-theme-quartz[class*=\"ag-theme-quartz\"] {\n    --ag-control-panel-background-color: #e4e4e4;\n    --ag-side-button-selected-background-color: #c3e6f7;\n\n    --ag-selected-tab-underline-width: 2px;\n    --ag-selected-tab-underline-transition-speed: 0.5s;\n\n}\n\n/* Color the the row group value (if grouped) */\n.ag-theme-quartz .ag-column-drop-cell {\n    font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
